import React from 'react';
import { useMsal } from '@azure/msal-react';

// Header navy global (v37.0). Visible en TODAS las pantallas autenticadas
// (Hub y modulos). Unico lugar con el boton Salir (D15) - NavBar NO lo duplica.
function Header() {
  const { instance, accounts } = useMsal();
  const nombreUsuario = accounts[0]?.name || accounts[0]?.username || '';

  const handleLogout = () => instance.logoutRedirect();

  return (
    <header style={{
      background: '#012E40', padding: '12px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      color: '#fff', flexShrink: 0, fontFamily: 'Segoe UI, sans-serif'
    }}>
      {/* Logo + nombre sistema */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          width: 28, height: 28, background: '#87B749', borderRadius: 4,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: 500, fontSize: 12, color: '#012E40'
        }}>JYA</div>
        <div style={{ fontSize: 13, fontWeight: 500 }}>
          Sistema Administrativo &middot; Infra Design CR
        </div>
      </div>

      {/* Usuario + salir */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, fontSize: 12 }}>
        <span style={{ opacity: 0.85 }}>{nombreUsuario}</span>
        <button onClick={handleLogout} style={{
          background: 'transparent', border: '1px solid rgba(255,255,255,0.25)',
          color: '#fff', cursor: 'pointer', padding: '5px 12px', borderRadius: 6,
          display: 'flex', alignItems: 'center', gap: 6, fontSize: 12,
          fontFamily: 'Segoe UI, sans-serif'
        }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.10)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
          aria-label="Cerrar sesion">
          <i className="ti ti-logout" style={{ fontSize: 15 }} aria-hidden="true" />
          Salir
        </button>
      </div>
    </header>
  );
}

export default Header;
